import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import { WB_LoaderOperationRow} from "../PA.Core/PAdbSchemaRows";

import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Loader_Operation} from "../PA.Core/PAdbSchema";
import {LoaderOperationBO} from "./LoaderOperationBO";


export class LoaderOperationBOValidations {

    static async Validation(aBO: LoaderOperationBO): Promise<void> {


        let dbContext = new PAdbContext({})

        let loaderOpRows: WB_LoaderOperationRow[] = await dbContext.findAll(esWB_Loader_Operation,
            {where: {DELETED_IND: {neq: '1'},
                    WB_LOADEROPERATION_ID : {neq: aBO.WB_LoaderOperation.cif.WB_LOADEROPERATION_ID},
                    LOADEROPERATION_ID: aBO.WB_LoaderOperation.cif.LOADEROPERATION_ID,
                    WB_MDSET_ID: aBO.WB_LoaderOperation.cif.WB_MDSET_ID,
                }})
        if (loaderOpRows.length)
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'loaderopalreadyexits',
                    type: MessageType.Error,
                    title: "Loader Operation already exits in this Master Data Set",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        else
            aBO.ValidateMessageProvider.removeMessage('loaderopalreadyexits')

    }

}
